import * as yup from "yup";

const createAppVersionValidator = yup
  .object({
    version: yup
      .string()
      .required("App version is required")
      .test("is-version", "Invalid version format. e.g 1.0.0", (value) =>
        /\d+\.\d+\.\d+$/.test(value)
      ),
    platform: yup.string().required("Platform is required"),
    description: yup.string().required("Description is required"),
    driver_force_update: yup
      .boolean()
      .default(false)
      .required("Driver force update is required"),
    passenger_force_update: yup
      .boolean()
      .default(false)
      .required("Passenger force update is required"),
  })
  .required();

export default createAppVersionValidator;
